// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"448ae3c2","239":"e39fb35b","453":"03346f77","455":"a85b2e49"}[chunkId] + ".chunk.js";
};